import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { AlertService } from '@app/_services';
import { MatDialog } from '@angular/material/dialog';
import {ContactService} from '@app/_components/contact';
import {MessageService} from 'primeng/api';




@Component({
    selector: 'app-contact-select',
    templateUrl: './contact-select.component.html',
    styleUrls: ['./contact-select.component.css'],
    standalone: false
})
export class ContactSelectComponent implements OnInit, OnChanges {


  constructor(
    private formBuilder: UntypedFormBuilder,
    private reportService: ReportService,
    private contactService: ContactService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private messageService: MessageService) {
  }

  texts: string[] = [];

  contactSuggestions: string[];

  contactSelectForm: UntypedFormGroup;


  @Output() messageEvent = new EventEmitter<string>();

  @Input() contacts;

  @Input() viewOnly: boolean;
  @Input() isPublicAndPublish: boolean;
  @Output() contactSelectedEvent = new EventEmitter<any>();

  ngOnInit() {
    if ( !this.contacts){
      this.contacts = [];
    }
    this.contactSelectForm = this.formBuilder.group({
      ContactSelect: [this.contacts],
    });
    this.contactSuggestions = [];
    this.contactSuggestions = this.contacts;
    this.contactSelectedEvent.emit(this.contactSelectForm.value.ContactSelect);
    // this.findContactsWith('');
  }

  // for each letter typed in autocomplete...
  onKeyInput(event) {
    let query = event.query;
    this.findContactsWith(query);
    return this.contactSuggestions;
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ',' || event.key === ' ') {
      let tokenInput = event.srcElement as any;
      console.log('tokenInput ' + JSON.stringify(tokenInput.value));
      if (tokenInput.value) {
        if (tokenInput.value) {
          tokenInput.value = tokenInput.value.replace(',', '').replace(' ', '');
        }
        if (this.validEMail(tokenInput.value)) {
          this.contactSelectForm.value.ContactSelect.push({emailAddress: tokenInput.value});
          this.contactSelectedEvent.emit(this.contactSelectForm.value.ContactSelect);
        } else {
          this.messageService.add({severity: 'error', summary: 'Failed ', detail: 'Mail Id is not valid'});
        }
        tokenInput.value = '';
      }
    }
  }

  onSelect(event) {
    // assemble the payload manually since we are using primeng
    console.log('onSelect: ' + JSON.stringify(event));
    let data: any = {};
    this.contactSelectedEvent.emit(this.contactSelectForm.value.ContactSelect);
  }

  validEMail(email: string) {
    let regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regEx.test(email);
  }


  onUnselect(event) {
    this.contactSelectedEvent.emit(this.contactSelectForm.value.ContactSelect);
  }

  findContactsWith(queryString: string) {
    let customFilter = {emailAddress: {'value': queryString, 'matchMode': 'in'}};
    this.contactService.fetchAllContacts(
      0, 0,
      'id',
      'asc',
      '',
      'event.globalFilter',
      customFilter).pipe(first()).subscribe(
      (res: any) => {
        this.contacts = res.data.contacts;
        this.contactSuggestions = [];
        this.contactSuggestions = this.contacts;
        /*for ( let i = 0; i < this.contacts.length; i++){
          this.contactSuggestions.push(this.contacts[i].emailAddress);
        }*/
      },
      (err: any) => {
        this.alertService.error(err);
      },
      () => {
      }
    );

  }

  ngOnChanges() {
  }

  focusGone(event: any) {
    let tokenInput = event.srcElement as any;
    console.log('tokenInput ' + JSON.stringify(tokenInput.value));
    if (tokenInput.value) {
      if (tokenInput.value.indexOf(',') > -1) {
        tokenInput.value = tokenInput.value.replace(',', '');
      }
      if (this.validEMail(tokenInput.value)) {
        this.contactSelectForm.value.ContactSelect.push({emailAddress: tokenInput.value});
        this.contactSelectedEvent.emit(this.contactSelectForm.value.ContactSelect);
      } /*else {
        this.messageService.add({severity: 'error', summary: 'Failed ', detail: 'Email Id is not valid'});
      }*/
      tokenInput.value = '';

    }
  }

}
